<template>
  <article class="filter-container mt-2">
    <div class="row align-items-end">
      <div class="col-12 col-md-4">
        <label>Seleccionar Asistente:</label>
        <CustomDropDown
          v-model="model"
          fieldkey="assistantId"
          fieldname="name"
          :options="assistants"
          placeholder="Seleccionar Asistente"
          clearable
        />
      </div>
      <div class="col-12 col-md-4 mt-2 mt-md-0">
        <ActionButton
          text="Añadir Asistente"
          variant="success"
          i="fas fa-user"
          :responsive="isMobile"
          @click="$emit('add-assistant')"
        />
      </div>
    </div>
  </article>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';

export default {
  name: 'AssistantsHeaderFilter',
  components: {
    ActionButton,
    CustomDropDown,
  },
  props: {
    selectedAssistant: {
      type: Object,
      default: null,
    },
    assistants: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get() {
        return this.selectedAssistant;
      },
      set(value) {
        this.$emit('update:selectedAssistant', value);
      },
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.filter-container {
  background-color: map.get($colors, 'white');
  padding: 15px;
  border-radius: 5px;
}

.filter-container label {
  color: map.get($colors, 'gray-6');
  font-size: 0.875rem;
}
</style>
